import { createSlice } from '@reduxjs/toolkit';

const modeSlice = createSlice({
  name: 'mode',
  initialState: {
    modes:"light",
    sideBarCollapes:'show',
    phoneToggle:'hide',
    printData: null
  },
  reducers: {
    setMode:(state)=>{
      state.modes = state.modes === "light" ? "dark" : "light";
    },
    setSideCollapes:(state)=>{
      state.sideBarCollapes = state.sideBarCollapes === "show" ? "hide" : "show";
    },
    setPhoneToggle:(state)=>{
      state.phoneToggle = state.phoneToggle === "hide" ? "show" : "hide";
    },
    setPrintData:(state, action)=>{
      state.printData = action.payload;
    }
  },
});

export const { setMode,setSideCollapes,setPhoneToggle, setPrintData } = modeSlice.actions;
export default modeSlice.reducer